'use client';

import { Modal, Text } from '@mantine/core';
import { useGlobalErrorStore } from '@/stores/useGlobalErrorStore';
import { formatErrorMessage } from '@/lib/formatError';

export default function ErrorModal() {
  const { error, clearError } = useGlobalErrorStore();
  const message = formatErrorMessage(error);

  return (
    <Modal opened={!!error} onClose={clearError} title="Something went wrong" centered>
      <Text color="red">{message}</Text>
    </Modal>
  );
}
